import classNames from 'classnames';
import { Select } from '@meitu/saas-ui';
import './index.less';

const ChartCommonSelect = (props: any) => (
    <Select
        {...props}
        className={classNames('chart-common-select', props.className)}
        popupClassName={classNames('chart-common-select__dropdown', props.popupClassName)}
    />
);

export default ChartCommonSelect as typeof Select;
